import { useMemo, useState } from "react";
import { bigNews } from "@/mocks/chaqua";

export default function BigNews() {
  const [query, setQuery] = useState("");

  const list = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return bigNews;
    return bigNews.filter(
      (n) => n.title.toLowerCase().includes(q) || n.summary.toLowerCase().includes(q) || n.cat.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <section id="big" className="scroll-mt-20 bg-white py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-leaf-600">Trending Now</span>
            <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">
              今日大瓜精选 <span className="text-coral-500">·</span> 值得点开
            </h2>
            <p className="mt-2 text-sm text-stone-500">编辑部为你挑选的今日热议与今日新鲜事，标题党退散，只看真内容。</p>
          </div>
          <div className="w-full sm:w-80">
            <label className="relative block">
              <span className="sr-only">搜索大瓜</span>
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-stone-400"></i>
              <input
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜标题 / 关键词找瓜…"
                className="w-full rounded-full border border-cream-300 bg-cream-50 py-2.5 pl-11 pr-4 text-sm text-stone-700 outline-none transition placeholder:text-stone-400 focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
              />
            </label>
          </div>
        </div>

        {list.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-cream-300 bg-cream-50 py-16 text-center">
            <i className="ri-fridge-line text-4xl text-cream-300" aria-hidden="true"></i>
            <p className="mt-3 text-sm text-stone-500">冰箱里暂时没有这个瓜，换个关键词再搜搜看？</p>
            <button
              type="button"
              onClick={() => setQuery("")}
              className="mt-4 inline-flex whitespace-nowrap rounded-full border border-coral-300 px-4 py-2 text-sm font-medium text-coral-600 transition hover:bg-coral-50"
            >
              清空搜索
            </button>
          </div>
        ) : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((n) => (
              <article
                key={n.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-cream-200 bg-white transition hover:-translate-y-1 hover:border-coral-200 hover:shadow-lg"
              >
                <div className="relative aspect-[10/7] w-full overflow-hidden bg-cream-100">
                  <img
                    src={n.img}
                    alt={n.title}
                    title={`${n.title}｜吃瓜在线今日热议`}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-black/50 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur-sm">
                    <i className="ri-flashlight-line" aria-hidden="true"></i>
                    {n.cat}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="text-base font-bold leading-snug text-stone-900 transition group-hover:text-coral-600">
                    {n.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-stone-500">{n.summary}</p>
                  <div className="mt-auto flex items-center justify-between pt-4 text-xs text-stone-400">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-time-line" aria-hidden="true"></i>
                      {n.time}
                    </span>
                    <span className="flex items-center gap-3 whitespace-nowrap">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" aria-hidden="true"></i>
                        {n.read}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line" aria-hidden="true"></i>
                        {n.comment}
                      </span>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}